// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"370":"c1fc4201","453":"9ac742e2"}[chunkId] + ".chunk.js";
};